import { z } from "zod";
import { PillarSchema } from "../../enums/metrics";
import { ContentBlockSchema } from "../../report/blocks";
import { MetricKeySchema } from "../../report/catalog";
import { IssueSchema } from "../issue/responses";

export const MetricCatalogSchema = z.object({
  key: MetricKeySchema,
  label: z.string(),
  pillar: z.string(),
  good: z.number(),
  watch: z.number(),
  target: z.number(),
  description: z.string(),
});

// Admin catalog view: `pillar` is narrowed to the enum so it round-trips into
// the update request.
export const MetricCatalogAdminSchema = MetricCatalogSchema.extend({
  pillar: PillarSchema,
});

export const MetricCatalogListResponseSchema = z.object({
  metrics: z.array(MetricCatalogAdminSchema),
});

export type MetricCatalogAdmin = z.infer<typeof MetricCatalogAdminSchema>;
export type MetricCatalogListResponse = z.infer<
  typeof MetricCatalogListResponseSchema
>;

// Metric detail is composed from the catalog entry, latest report signal,
// metric content blocks, metric-filtered issues, and measured page scores.
export const MetricDetailSchema = z.object({
  metric: MetricCatalogSchema,
  signal: z
    .object({
      score: z.number().nullable(),
      delta: z.number().nullable(),
      detail: z.string(),
      trend: z.array(z.number()),
    })
    .nullable(),
  blocks: z.array(ContentBlockSchema),
  issues: z.array(IssueSchema),
  pages: z.array(
    z.object({
      pageId: z.uuid(),
      title: z.string().nullable(),
      path: z.string(),
      score: z.number().int().min(0).max(100),
      detail: z.string(),
    }),
  ),
});

export type MetricDetail = z.infer<typeof MetricDetailSchema>;
export type MetricCatalog = z.infer<typeof MetricCatalogSchema>;
